import React from 'react';
import ReactDOM from 'react-dom';
import EligibilityCheckContainer from './EligibilityCheckContainer.jsx';

function initAddToBasketButtonWrapper(initAddToBasketButtonCallback = () => {}) {
  const targetNode = document.createElement('div');
  document.body.appendChild(targetNode);
  if (targetNode) {
    ReactDOM.render(
      <EligibilityCheckContainer initAddToBasketButton={initAddToBasketButtonCallback} />,
      targetNode
    );
  }
}
export default initAddToBasketButtonWrapper;
